import type { Account } from './useAccounts'

/**
 * The ONE "is this linked account effectively disconnected" predicate, read by
 * `accountHealth` (what the row says), `countsTowardTotals` (whether its
 * balance is summed) and both staleness filters (whether its frozen
 * `last_synced_at` may hold a surface stale), so display, totals and freshness
 * cannot disagree. True for `connection_status: 'disconnected'` and for a
 * non-manual account with a null status (a dangling row: no connection left to
 * report on). A manual account is never disconnected.
 *
 * Its own module, type-only on `useAccounts`, because `useAccounts` itself
 * needs it for `oldestStaleSync` and `accountHealth` imports `useAccounts`.
 */
export function isEffectivelyDisconnected(a: Account): boolean {
  if (a.provider === 'manual') return false
  return a.connectionStatus === 'disconnected' || a.connectionStatus === null
}
